import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Params } from '@angular/router';
import { SharedModule } from '../../../shared.module';
import { WidgetNumberDisplayComponent } from '../widget-number-display/widget-number-display.component';

@Component({
  selector: 'app-widget-tickets-display',
  styleUrls: ['./widget-tickets-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetNumberDisplayComponent, SharedModule],
  template: `
    <app-widget-number-display
      class="widget-tickets-display dimensions-stretch"
      [status]="'OPEN'"
      [number]="ticketCount"
      [label]="ticketCount || 0 | pluralize: 'Ticket'"
      [hyperlink]="hyperlink"
      [queryParams]="queryParams"
      [ctaText]="'View Tickets'"
      [navigateOnClick]="navigateOnClick"
      [loading]="loading"
    >
      <i
        titlePrefixIcon
        class="widget-element-icon custom-icon ticket_lrg_cir_white"
      ></i>

      <div class="ticket-icon">
        @if (ticketCount > 0) {
          <img
            alt="ticket widget"
            src="/assets/images/img_widget_ticket@2x.png"
          />
        } @else {
          <img alt="ticket widget" src="/assets/images/img_widget_ok@2x.png" />
        }
      </div>
    </app-widget-number-display>
  `,
})
export class WidgetTicketsDisplayComponent {
  @Input() queryParams: Params | null = null;

  @Input() hyperlink: string | null = null;

  @Input() navigateOnClick: boolean = false;

  @Input() ticketCount: number | null = 0;

  @Input() loading: boolean = true;
}
